var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 4.16667C10.8333 3.24619 11.5795 2.5 12.5 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V7.5C17.5 8.42047 16.7538 9.16667 15.8333 9.16667H12.5C11.5795 9.16667 10.8333 8.42048 10.8333 7.5V4.16667ZM15.8333 4.16667H12.5V7.5H15.8333V4.16667Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 12.5C10.8333 11.5795 11.5795 10.8333 12.5 10.8333H15.8333C16.7538 10.8333 17.5 11.5795 17.5 12.5V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H12.5C11.5795 17.5 10.8333 16.7538 10.8333 15.8333V12.5ZM15.8333 12.5H12.5V15.8333H15.8333V12.5Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C8.42047 2.5 9.16667 3.24619 9.16667 4.16667V7.5C9.16667 8.42047 8.42048 9.16667 7.5 9.16667H4.16667C3.24619 9.16667 2.5 8.42048 2.5 7.5V4.16667ZM7.5 4.16667H4.16667V7.5H7.5V4.16667Z",
    fill: "#0F172A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12.5C2.5 11.5795 3.24619 10.8333 4.16667 10.8333H7.5C8.42047 10.8333 9.16667 11.5795 9.16667 12.5V15.8333C9.16667 16.7538 8.42048 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5ZM7.5 12.5H4.16667V15.8333H7.5V12.5Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.11008cc519feca523eb42b1a6f2e9dc5.svg";
export { ForwardRef as ReactComponent };